import Vue from 'vue'
import App from './App.vue'
import router from './router'
import config from './config'
import api from './api'
import store from './store'
import { Loading } from 'vant'
import { XesCookie } from '@xes/terra-utils'
import { isApp, isAndroid } from '@/common/utils/index'
import WXJsBridge from '@xes/wxjsbridge'

import { initLogSDKNew } from '@/common/utils/main-logadmin'
// 日志
import logInfo from './config/log.json'
initLogSDKNew(logInfo.logId)

if (isApp) {
  WXJsBridge &&
    WXJsBridge.setNavigationBar({
      navigationBarType: 2,
      leftButtonType: isAndroid ? 1 : 0
      // navigationBarType: 2
    })
}

Vue.use(Loading)

// 全局配置信息
Vue.prototype.$api = api
Vue.prototype.$config = config
Vue.prototype.$xesCookie = XesCookie

// 配置微信分享
window.onload = () => {
  if (window._xesShare.shareClient === 1 && config.xesShare.title) {
    window._xesShare.shareLink(config.xesShare)
  }
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
